import plugin from "../../lib/plugin";
import { GAServices } from "../../services/ga-services";
const ELEMENT_SELECTOR = "[data-product-slider]";
const HEIGHT_SELECTOR = ".product-teaser__container";
const BULLET_SELECTOR = ".swiper-pagination-bullet";
const HIDE_NAVIGATION_CLASS = "swiper--hide-navigation";

class ProductSlider {
	constructor(element, options) {
		this.element = element;
		this.options = options;
		this.swiper = window.swiper;
		this.slides = $(element).find(".swiper-slide");
		this.nextButton = document.querySelector(this.options.nextButtonSelector);
		this.previousButton = document.querySelector(this.options.previousButtonSelector);
		this.$el = $(this.element);
		if (typeof this.swiper == "undefined") {
			var mod = this;
			System.import(
				/* webpackChunkName: "core/vendor/swiper/swiper-bundle.min" */
				"@core/vendor/swiper/swiper-bundle.min"
			).then((swiper) => {
				mod.swiper = swiper;
				window.swiper = swiper;
				mod.init();
			});
		} else {
			this.init();
		}
	}

	setAnySlidesClass() {
		var bullets = $(this.element).find(BULLET_SELECTOR);
		if (bullets.length > 1) {
			$(this.element).removeClass(HIDE_NAVIGATION_CLASS);
		} else {
			$(this.element).addClass(HIDE_NAVIGATION_CLASS);
		}
	}

	init() {
		var mod = this;
		this.slider = new this.swiper(this.element, {
			slidesPerView: 2,
			slidesPerGroup: 2,
			// slidesPerGroupSkip: 2,
			// spaceBetween: 0,
			centeredSlides: false,
			// cssMode: true,
			mousewheel: false,
			keyboard: {
				enabled: true,
			},
			// loop: true,
			// loopFillGroupWithBlank: true,
			slideVisibleClass: 'slide-active',
			watchSlidesVisibility: true,
			breakpoints: {
				640: {
					slidesPerView: 2,
					slidesPerGroup: 2,
				},
				768: {
					slidesPerView: 3,
					slidesPerGroup: 3,
				},
				1024: {
					slidesPerView: 4,
					slidesPerGroup: 4,
				},
			},
			on: {
				init: function () {
					setTimeout(function () {
						mod.setAnySlidesClass();
					}, 200);
				},
				resize: function () {
					mod.setAnySlidesClass();
				},
				slideChangeTransitionEnd: function() {
					mod.tracking();
				}
			},
			pagination: {
				el: ".swiper-pagination",
				type: "bullets",
				bulletElement: "button",
				bulletClass: "swiper-pagination-bullet",
				renderBullet: function (index, className) {
					return `<button type="button" class="${className} u-focus-keyboard--circle" aria-label="Go to slide ${index}"></button>`;
				},
				clickable: true,
			},
			navigation: {
				nextEl: mod.nextButton,
				prevEl: mod.previousButton,
			},
			threshold: 20
		});

		this.trackingSelect();
		this.tracking();
		$(window).on('scroll', () => {
			this.tracking();
		});
	}

	tracking() {
		const $tabBlock = this.$el.closest('.has-tab');
		if ($tabBlock.length) {
			const $activeTab = $tabBlock.find('.recommendations-slider-content:not(.--is-closed)');
			if (this.$el.parents('.recommendations-slider-content:not(.--is-closed)').length > 0) {
				GAServices.viewItemTracking($activeTab, true);
			}
		} else {
			GAServices.viewItemTracking($(this.element), true);
		}
	}

	trackingSelect() {
		const $tabs = this.$el.closest('.has-tab');
		const pageType = $('body').data('pageTypeName');
		this.$el.find('[ga-tracking-link]').each((index, el) => {
			if (!$tabs.length) {
				const $block = this.$el.closest('.layout');
				if ($block) {
					const $blockTitle = $block.find('.layout__title');
					const itemListName = pageType + ' - ' + $blockTitle.text().trim() ;
					el.closest('[ga-tracking-item]').setAttribute('ga-item-list-name', itemListName);
				}
			}
			GAServices.selectItem(el, false);
		});
	}
}

ProductSlider.DEFAULTS = {};

plugin("productSlider", ProductSlider);

export function exec() {
	$(document).ready(() => {
		$(ELEMENT_SELECTOR).productSlider();
	});
}



// WEBPACK FOOTER //
// ./client/src/core/components/swiper/product-slider.js